import './busproject.css';

import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import ListGroup from 'react-bootstrap/ListGroup';
import Accordion from 'react-bootstrap/Accordion';
import Carousel from 'react-bootstrap/Carousel';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

import mainTimes from './Images/RoutesMapOneTransit.png'
import subRoutes from './Images/SubRoutesTransit.png'


import uproutes from './Files/UP/routes.txt';
import uptrips from './Files/UP/trips.txt';

import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';






function DRTData() {
  const [routesData, setRoutesData] = useState([]);
  const [calendarData, setCalendarData] = useState([]);
  const [stopTimesData, setStopTimesData] = useState([]);
  const [tripsData, setTripsData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [uniqueServiceIds, setUniqueServiceIds] = useState([]);

  

  useEffect(() => {



    const loadRoutes = async () => {
      const response = await fetch("./transit/drt/routes.txt");
      const responseText = await response.text();
      const rows = responseText.split("\n");
      const headers = rows[0].split(",");
      const routeShortNameIndex = headers.indexOf("route_id");
      const routeLongNameIndex = headers.indexOf("route_long_name");
      const routeTextColorIndex = headers.indexOf("route_color");

      const parsedData = rows.slice(1).map((row) => {
        const cells = row.split(",");
        return {
          route_short_name: cells[routeShortNameIndex],
          route_long_name: cells[routeLongNameIndex],
          route_text_color: `#${cells[routeTextColorIndex]}`,
        };
      });

      setRoutesData(parsedData);
    };


    const loadCal = async () => {
      const response = await fetch("./transit/drt/calendar.txt");
      const responseText = await response.text();

      const rows = responseText.split("\n").map((row) => row.trim()); // Define 'rows' here

      // Trim the first line (header) to remove any trailing comma
      const [headerLine, ...dataLines] = responseText.split("\n");
      const trimmedHeader = headerLine.trim().replace(/,$/, "");

      const headers = trimmedHeader.split(",");
      const servDayNameIndex = headers.indexOf("service_id");
      const mondayIndex = headers.indexOf("monday");
      const tuesdayIndex = headers.indexOf("tuesday");
      const wednesdayIndex = headers.indexOf("wednesday");
      const thursdayIndex = headers.indexOf("thursday");
      const fridayIndex = headers.indexOf("friday");
      const saturdayIndex = headers.indexOf("saturday");
      const sundayIndex = headers.indexOf("sunday");
      const startDateIndex = headers.indexOf("start_date");
      const endDateIndex = headers.indexOf("end_date");

      const parsedData = rows.slice(1).map((row) => {
        const cells = row.split(",");



        return {
          Service: cells[servDayNameIndex],
          Monday: cells[mondayIndex],
          Tuesday: cells[tuesdayIndex],
          Wednesday: cells[wednesdayIndex],
          Thursday: cells[thursdayIndex],
          Friday: cells[fridayIndex],
          Saturday: cells[saturdayIndex],
          Sunday: cells[sundayIndex],
          Starts: cells[startDateIndex],
          Ends: cells[endDateIndex]
        };
      });

      setCalendarData(parsedData);
    };



    const loadStopTimes = async () => {
      try {
        await loadTrips();
        const response = await fetch("./transit/drt/stop_times.txt");
        const responseText = await response.text();
        const rows = responseText.split("\n");
        const headers = rows[0].split(",");
        const arrivalTimeIndex = headers.indexOf("arrival_time");
        const departTimeIndex = headers.indexOf("departure_time");
        const stopIdIndex = headers.indexOf("stop_id");
        const stopSequenceIndex = headers.indexOf("stop_sequence");
        const tripIdIndex = headers.indexOf("trip_id");
    
        const uniqueTrips = new Map();
        const maxStopSequences = new Map();
        const firstStopDepartures = new Map();
    
        // Convert rows to array of objects for easier access
        const stopTimeObjects = rows.slice(1).map(row => {
          const cells = row.split(",");
          return {
            trip_id: cells[tripIdIndex],
            arrival_time: cells[arrivalTimeIndex],
            depart_time: cells[departTimeIndex],
            stop_sequence: parseInt(cells[stopSequenceIndex], 10),
            stop_id: cells[stopIdIndex]
          };
        });
    
        // Group by trip_id
        const trips = new Map();
        for (const stopTime of stopTimeObjects) {
          const tripId = stopTime.trip_id;
          if (!trips.has(tripId)) {
            trips.set(tripId, []);
          }
          trips.get(tripId).push(stopTime);
        }
    
        for (const [tripId, tripStops] of trips) {
          const matchingTrip = tripsData.find(trip => trip.trip_id === tripId);
          if (!matchingTrip) continue;
    
          // Sort tripStops by stop_sequence
          tripStops.sort((a, b) => a.stop_sequence - b.stop_sequence);
    
          const firstStopDeparture = tripStops[0].depart_time;
          const lastStop = tripStops[tripStops.length - 1];
    
          const key = `${matchingTrip.route_id}-${matchingTrip.trip_headsign}-${matchingTrip.direction_name}-${lastStop.stop_sequence}`;
    
          const timeElapsed = calculateTimeDifference(firstStopDeparture, lastStop.depart_time);
    
          uniqueTrips.set(key, {
            route_id: matchingTrip.route_id,
            trip_headsign: matchingTrip.trip_headsign,
            direction_name: matchingTrip.direction_name,
            stop_sequence: lastStop.stop_sequence,
            arrival_time: lastStop.arrival_time,
            depart_time: lastStop.depart_time,
            stop_id: lastStop.stop_id,
            time_elapsed: timeElapsed,
          });
        }
    
        const parsedData = Array.from(uniqueTrips.values());
        setStopTimesData(parsedData);
    
      } catch (error) {
        console.error("Error loading stop times:", error);
      }
    };

    function calculateTimeDifference(startTime, endTime) {
      const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);
    
      // Create Date objects with the current date to handle potential day changes
      const now = new Date();
      const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHours, startMinutes, startSeconds);
      const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHours, endMinutes, endSeconds);
    
      // If endTime is earlier than startTime, assume it's the next day
      if (endDate < startDate) {
        endDate.setDate(endDate.getDate() + 1); 
      }
    
      const diffInSeconds = (endDate.getTime() - startDate.getTime()) / 1000;
      return diffInSeconds; 
    }

    

    const loadTrips = async () => {
      const response = await fetch("./transit/drt/trips.txt");
      const responseText = await response.text();
      const rows = responseText.split("\n");
      const headers = rows[0].split(",");
      const routeIdIndex = headers.indexOf("route_id");
      const tripHeadsignIndex = headers.indexOf("trip_headsign");
      const directionNameIndex = headers.indexOf("direction_name");
      const serviceIdIndex = headers.indexOf("service_id");
      const tripIdIndex = headers.indexOf("trip_id");


      const parsedData = rows.slice(1).map((row) => {
        const cells = row.split(",");
        return {
          route_id: cells[routeIdIndex],
          trip_headsign: cells[tripHeadsignIndex],
          direction_name: cells[directionNameIndex],
          service_id: cells[serviceIdIndex],
          trip_id: cells[tripIdIndex]
        };
      });

      setTripsData(parsedData);

      // Extract unique non-blank service_ids
      const uniqueIds = [
        ...new Set(
          parsedData
            .filter((trip) => trip.service_id && trip.service_id.trim() !== "")
            .map((trip) => trip.service_id)
        ),
      ];
      setUniqueServiceIds(uniqueIds);
    };

    loadRoutes();
    loadCal();
    loadTrips();
    loadStopTimes();
  }, []);

  useEffect(() => {
    const processData = () => {
      const newProcessedData = routesData.map((route) => {
        const routeTrips = tripsData.filter(
          (trip) => trip.route_id === route.route_short_name
        );

        const tripsByDirection = routeTrips.reduce((acc, trip) => {
          const direction = trip.direction_name;
          acc[direction] = acc[direction] || [];
          acc[direction].push(trip.trip_headsign);
          return acc;
        }, {});

        const uniqueTripsByDirection = Object.entries(
          tripsByDirection
        ).map(([direction, headsigns]) => ({
          direction,
          headsigns: [...new Set(headsigns)],
        }));

        return { ...route, tripsByDirection: uniqueTripsByDirection };
      });

      setProcessedData(newProcessedData);
    };

    if (routesData.length > 0 && tripsData.length > 0) {
      processData();
    }
  }, [routesData, tripsData]);

  useEffect(() => {
    const applyStyles = () => {
      const tableCells = document.querySelectorAll(".route-long-name");
      let currentRoute = null;
      tableCells.forEach((cell) => {
        const row = cell.parentNode;
        const routeName = cell.textContent;

        if (
          row.previousElementSibling === null ||
          !row.previousElementSibling.querySelector(".route-long-name")
        ) {
          currentRoute = routeName;
        }

        const routeData = processedData.find(
          (route) => route.route_long_name === currentRoute
        );
        if (routeData) {
          const color = routeData.route_text_color;
          cell.style.color = "white";
          cell.style.fontWeight = "bold";
          cell.style.textShadow = `3px 3px 0 ${color}`;
        }
      });
    };

    if (processedData.length > 0) {
      applyStyles();
    }
  }, [processedData]);


  // Helper function to format date
  const formatDate = (dateString) => {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div>
      <h2>Service Date Info:</h2>
      This agency currently breaks their trips down into these categories, note the start/end date and the days of the week each service type runs:
      <br></br><br></br>
      <Table bordered hover variant="dark">
        <thead>
          <tr>
            {Object.keys(calendarData[0] || {}).map((key) => (
              <th key={key}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {calendarData.map((item, index) => (
            <tr key={index}>
              {Object.values(item).map((value, index) => (
                <td key={index}>
                  {/* Conditionally format Starts and Ends values, hide 0s for weekdays */}
                {index === 8 || index === 9
                  ? formatDate(value)
                  : index >= 1 && index <= 7 && value === "1" // Check if it's a weekday column and the value is 1
                  ? "Yes" // Hide 0 values for weekdays
                  : index >= 1 && index <= 7 && value === "0" // Check if it's a weekday column and the value is 0
                  ? "" // Hide 0 values for weekdays
                  : value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>



      <h2>Route Table:</h2>
      <Table bordered hover variant="dark" size="sm">
        <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
          <tr style={{ backgroundColor: "#343a40 !important" }}>
            <th>Route</th>
            <th>Direction</th>
            <th>Trip Headsign</th>
            {uniqueServiceIds.map((serviceId) => (
              <th key={serviceId}>#{serviceId} Trips</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {processedData.map((route, rowIndex) => (
            <React.Fragment key={rowIndex}>
              {route.tripsByDirection.map((directionData, dirIndex) => (
                directionData.headsigns.map((headsign, headsignIndex) => (
                  <tr key={`${dirIndex}-${headsignIndex}`}>
                    {dirIndex === 0 && headsignIndex === 0 && (
                      <td
                        className="route-long-name"
                        rowSpan={
                          route.tripsByDirection.flatMap((d) => d.headsigns)
                            .length
                        }
                      >
                        {route.route_long_name}
                        <br></br>
                        <Button variant="primary" size="sm">View More Info</Button>
                      </td>
                    )}
                    {headsignIndex === 0 && (
                      <td rowSpan={directionData.headsigns.length}>
                        {directionData.direction}
                      </td>
                    )}
                    <td>{headsign}</td>
                    {uniqueServiceIds.map((serviceId) => {
                      const count = tripsData.filter(
                        (trip) =>
                          trip.route_id === route.route_short_name &&
                          trip.direction_name === directionData.direction &&
                          trip.trip_headsign === headsign &&
                          trip.service_id === serviceId
                      ).length;

                      return (
                        <td key={serviceId}>
                          {count > 0 ? count : ""}
                        </td>
                      );
                    })}
                  </tr>
                ))
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>




      <h2>Stop Times Table:</h2>
      <Table bordered hover variant="dark">
        <thead>
          <tr>
            {Object.keys(calendarData[0] || {}).map((key) => (
              <th key={key}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {stopTimesData.map((item, index) => (
            <tr key={index}>
              {Object.values(item).map((value, index) => (
                <td key={index}>
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>





    </div>
  );
}









    


function Busproject(){

  

    return (
        <div id="busprojectdiv">
        <div class="leftrightdiv">
            <h1>Transit Info</h1>
            <a href="/#/projects" class="returntorpojects">Return to Projects</a>
        </div>

        <ListGroup variant="flush">
            <ListGroup.Item><b>Description:</b> This tool shows statistics about Durham Region Transit (DRT).</ListGroup.Item>
        </ListGroup>
        <br></br>

        <Alert variant="danger">
      <Alert.Heading>This data is not always kept up to date!</Alert.Heading>
      <p>
        This project was developed as a "proof of concept", new data files have to be uploaded manually currently, so data may fall out of date.
      </p>
      <hr />
      <p className="mb-0">
        For actual trip planning, use the <a id="speciallink" href="https://www.durhamregiontransit.com/en/index.aspx" target="_blank">Durham Region Transit website</a>.
        <br></br>
        Contains public sector information made available under The Regional Municipality of Durham's Open Data Licence
      </p>
    </Alert>

        <br></br>

        <h2>Transit Systems</h2>
        <p>Select a transit system.</p>

        <Tabs
      defaultActiveKey="DRT"
      id="fill-tab-example"
      className="mb-3"
      fill
    >

      <Tab eventKey="DRT" title="Durham Region Transit">
        Data was obtained on Jan 17, 2025.
        <br></br>
        <br></br>
        <DRTData></DRTData>
      </Tab>
    </Tabs>

      

        <br></br>

        <h2>Updates</h2>
        
        <Accordion>

            <Accordion.Item eventKey="0">
            <Accordion.Header>Initial Version</Accordion.Header>
            <Accordion.Body>
            <ul>
                <li>Transit Systems Implemented: DRT</li>
                <li>Currently lists basic info about routes.</li>
            </ul> 
            </Accordion.Body>
            </Accordion.Item>
            
        </Accordion>
        <br></br>
      


    </div>
    )
}

export default Busproject;